import { motion } from "motion/react";
import "./HomeAnimation.css";
import { NavLink } from "react-router";

export default function HomeAnimation() {
  return (
    <div className="hero-container">
        <div className="hero">
        <motion.div>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            viewport={{ once: true }}
            className="hero-h1"
          >
          Need Haulage?
          </motion.h1>

          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.0 }}
            viewport={{ once: true }}
            className="hero-h2"
          >
            We've got you covered
          </motion.h2>
          <motion.div
            className="inline-logo-text"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.4 }}
            viewport={{ once: true }}
          >
            <h1 className="logo-text-1">FRIENDLY</h1>
            <h1 className="logo-text-2">TRANSPORT</h1>
          </motion.div>
        </motion.div>
      </div>
       <div className="road-wrapper">
        <motion.div
          className="truck-div"
          initial={{ x: "-250%" }}
          animate={{ x: 0 }}
          transition={{
            delay: 1.0,
            duration: 2.0
          }}
          viewport={{ once: true }}
          >
          <motion.span
          className="truck-text"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            delay: 1.3,
            duration: 0.5,
          }}
        >
          <h3>Delivering more than just freight.</h3>
          </motion.span>
          <motion.img src="/lorry.png" className="lorry"/>
      </motion.div>
      </div>
      <motion.button
            className="hero-btn"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            viewport={{ once: true }}
          >
          <NavLink to='/Contact'> Enquire Now </ NavLink>
      </motion.button>
  </div>
  );
}